import React from 'react';
import { StyleSheet } from 'react-native';
import Svg, { Circle, Defs, RadialGradient, Stop } from 'react-native-svg';
import { colors } from '../../theme/tokens';

export interface LueurFloueProps {
  taille: number;
  top?: number;
  bottom?: number;
  left?: number;
  right?: number;
  id: string;
}

/**
 * Forme décorative du fond de l'écran de préparation : une lueur bleu électrique très atténuée, qui
 * s'efface vers ses bords — floue, sans contour net. Remplace les formes à bord franc (dont un quart
 * de cercle qui passait derrière le bouton ✕).
 */
export function LueurFloue({ taille, top, bottom, left, right, id }: LueurFloueProps) {
  return (
    <Svg width={taille} height={taille} style={[styles.lueur, { top, bottom, left, right }]} pointerEvents="none">
      <Defs>
        <RadialGradient id={id} cx="50%" cy="50%" r="50%">
          <Stop offset="0" stopColor={colors.electric} stopOpacity={0.22} />
          <Stop offset="1" stopColor={colors.electric} stopOpacity={0} />
        </RadialGradient>
      </Defs>
      <Circle cx={taille / 2} cy={taille / 2} r={taille / 2} fill={`url(#${id})`} />
    </Svg>
  );
}

const styles = StyleSheet.create({ lueur: { position: 'absolute' } });
